import * as React from 'react';

import { translate } from '~l10n/client';
import { WorkspaceRole } from 'clients/app/src/api/workspaces/getWorkspaceMembers';

import { CopyableInputControl } from '~shared/components/CopyableInputControl';
import { Spinner } from '~shared/components/Spinner';

import { useInviteLink } from './hooks';

interface InvitesDialogSectionControlLinkProps {
  workspaceId: string;
  workspaceRole: WorkspaceRole;
}

export function InvitesDialogSectionControlLink({
  workspaceId,
  workspaceRole,
}: InvitesDialogSectionControlLinkProps) {
  const inviteLink = useInviteLink({ workspaceId, workspaceRole });

  if (!inviteLink.data) {
    return <Spinner />;
  }

  return (
    <CopyableInputControl
      label={translate('Invite Link')}
      value={inviteLink.data.url}
    />
  );
}
